import emojiRegex from 'emoji-regex';

const diameterRegx = /Ø|⌀/g;
// `RegExp(source)` drops the flags of the composed patterns, so 'g' has to be restated
// here — without it only the first emoji of a product name was stripped.
export const emojiPattern = new RegExp(`${emojiRegex().source}|${diameterRegx.source}`, 'g');
